import React, { useEffect, useState } from "react";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";

import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { getPartsRepairList } from "../../services/RepairServices";

const RepairPart = () => {
  const location = useLocation();
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [repairList, setRepairList] = useState([]);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [modifyQuantityModal, setModifyQuantityModal] = useState(false);
  const [quantityData, setQuantityData] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [quantityStore, setQuantityStore] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);

  const handleCheckboxChange = (item) => {
    setSelectedRows((prevSelected) => {
      const isAlreadySelected = prevSelected.some((row) => row.id === item.id);
      if (isAlreadySelected) {
        return prevSelected.filter((row) => row.id !== item.id);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedRows.length === quantityData?.part_qty_list?.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(quantityData.part_qty_list);
    }
  };

  const isAllSelected =
    selectedRows.length === quantityData?.part_qty_list?.length &&
    quantityData?.part_qty_list?.length > 0;

  // const handleQuantityModalOpen = (e, item) => {
  //   setQuantityData(item);
  //   setModifyQuantityModal(true);
  // };

  const handleQuantityModalOpen = (e, item) => {
    setSelectedItem(item);
    setQuantityData(item);
    setSelectedRows(quantityStore[item.id] || []); // restore previous selection
    setModifyQuantityModal(true);
  };

  const handleQuantityModalClose = () => {
    setModifyQuantityModal(false);
    setSelectedRows([]);
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value);
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }
    setParams(paramsObj);
  };

  const fetchRepairParts = () => {
    let data = { ...params };
    getPartsRepairList(data)
      .then((response) => {
        setRepairList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchRepairParts(data);
    },
    [params],
  );

  // const handleQuantityForm = (e) => {
  //   e.preventDefault();

  //   setSelectedStoreRows(selectedRows);
  //   setModifyQuantityModal(false)
  // };

  const handleQuantityForm = (e) => {
    e.preventDefault();

    if (!selectedItem) return;

    setQuantityStore((prev) => ({
      ...prev,
      [selectedItem.id]: selectedRows, // save store-wise quantity
    }));

    setModifyQuantityModal(false);
  };

  const buildPayload = () => {
    let payload = [];

    Object.keys(quantityStore).forEach((partId) => {
      const storeRows = quantityStore[partId];

      storeRows.forEach((row) => {
        payload.push({
          parts_id: row.parts_id,
          uuid: row.uuid || "",
          qty: row.qty || 1,
          location_ids: row.location_ids || "",
          part_rating: row.part_rating || 0,
          location_name: row.location_name || "",
          id: row?.id,
        });
      });
    });

    return payload;
  };

  const handleSubmitQuantity = (e) => {
    e.preventDefault();

    const selectedRows = buildPayload();

    if (selectedRows.length > 0) {
      navigate("/parts-inventory-addparts", {
        state: { selectedRows },
      });
    } else {
      toast.error(t("no_parts_selected_add_one"));
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                {/* <h1 className="page-title">Part Side</h1> */}
              </div>
              <div className="col-sm-6"></div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new ">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="">
                    <div className="">
                      <div className="card-header">
                        <div
                          className="card-title m-0 float-left"
                          style={{ width: "50%" }}
                        >
                          <input
                            type="text"
                            className="form-control"
                            value={params.search}
                            onChange={(e) => handleParams(e, "search")}
                            placeholder={t("search")}
                          ></input>
                        </div>
                        <div className="card-title m-0 float-right d-flex">
                          <button
                            type="button"
                            className="btn btn-block btn-primary"
                            style={{ width: "175px" }}
                            onClick={handleSubmitQuantity}
                          >
                            Submit All Quantity
                          </button>
                        </div>
                      </div>
                      <div className="card-body fuelCardB">
                        <div className="vehicleThBg table-responsive">
                          <table className="table table-bordered rounded-table table table-striped table-hover">
                            <thead>
                              <tr>
                                <th style={{ width: "10%" }}>
                                  {t("internal_id")}
                                </th>
                                <th style={{ width: "10%" }}>{t("catalog")}</th>
                                <th style={{ width: "10%" }}>{t("make")}</th>
                                <th style={{ width: "10%" }}>{t("Model")}</th>
                                <th style={{ width: "10%" }}>{t("year")}</th>

                                <th
                                  className="col-form-label ml-2 Label-my form-label form-label"
                                  style={{ width: "0%" }}
                                >
                                  {" "}
                                  {t("action")}{" "}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {" "}
                              {repairList?.map((item, index) => {
                                return (
                                  <>
                                    <tr>
                                      <td>{item?.parts_internal_id}</td>
                                      <td>{item?.namePartPT}</td>
                                      <td>{item.vehicle_model_name}</td>
                                      <td>{item.vehicle_make_name}</td>
                                      <td>{item.vehicle_year}</td>
                                      <td className="d-flex">
                                        <button
                                          type="button"
                                          className="btn  btn-icon-text mr-2"
                                          onClick={(e) =>
                                            handleQuantityModalOpen(e, item)
                                          }
                                        >
                                          <i className="bi bi-bag"></i>{" "}
                                          <span className="ms-2">
                                            {t("quantity")}
                                          </span>
                                        </button>
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}{" "}
                            </tbody>{" "}
                            {repairList && repairList?.length === 0 && (
                              <tr>
                                <td colSpan={7} className={`text-center`}>
                                  {" "}
                                  {t("no_record_found")}
                                </td>
                              </tr>
                            )}
                          </table>
                        </div>
                      </div>{" "}
                      {/* /.card-body */}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div className="card-footer card-footer-part clearfix">
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>

        <Modal isOpen={modifyQuantityModal}>
          <ModalHeader>{t("quantity")}</ModalHeader>
          <Form method={`post`} onSubmit={handleQuantityForm}>
            <ModalBody>
              <div className="row">
                <div className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0">
                  <table className="rounded-table table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }}>
                          <input
                            type="checkbox"
                            checked={isAllSelected}
                            onChange={handleSelectAll}
                          />
                        </th>
                        <th style={{ width: "10%" }}>{t("quantity")}</th>
                        <th style={{ width: "10%" }}>{t("location_name")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {quantityData?.part_qty_list?.filter(
                        (item) => item.is_sold === 0,
                      ).length > 0 ? (
                        quantityData.part_qty_list
                          .filter((item) => item.is_sold === 0)
                          .map((item, index) => (
                            <tr key={item.id ?? index}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedRows.some(
                                    (row) => row.id === item.id,
                                  )}
                                  onChange={() => handleCheckboxChange(item)}
                                />
                              </td>
                              <td>{item.qty}</td>
                              <td>{item.location_name || "-"}</td>
                            </tr>
                          ))
                      ) : (
                        <tr className="scrollBrdr">
                          <td colSpan="100%">No results found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                disabled={isModifyButtonLoad}
                onClick={handleQuantityModalClose}
                style={{ width: "100px", marginTop: "10px" }}
              >{t("close")}<i className="bi bi-x-lg"></i>
              </button>
              {!isModifyButtonLoad &&
                quantityData?.part_qty_list?.length > 0 && (
                  <button
                    type="submit"
                    className="btn btn-block btn-primary"
                    style={{ width: "100px", marginTop: "10px" }}
                  >
                    Ok <i className="bi bi-check2"></i>
                  </button>
                )}
              {isModifyButtonLoad && (
                <Button
                  color="success"
                  type={`button`}
                  disabled={true}
                  className={`btn-square`}
                >
                  <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                  {t("loading")}
                </Button>
              )}
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default RepairPart;
